/* src/app/components/HeaderBar/styles.js */

export default theme => ({
  bar: {
    zIndex: 1201,
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/HeaderBar/styles.js